import { render, staticRenderFns } from "./Svg404.vue?vue&type=template&id=c23f7410&scoped=true"
import script from "./Svg404.vue?vue&type=script&lang=js"
export * from "./Svg404.vue?vue&type=script&lang=js"
import style0 from "./Svg404.vue?vue&type=style&index=0&id=c23f7410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23f7410",
  null
  
)

export default component.exports